import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Skeleton } from 'site-modules/shared/components/skeleton/skeleton';

export function TrimsCtaSkeleton({ isDealerlessOem = false }) {
  return (
    <div className="trims-cta-skeleton size-16 w-100" aria-hidden>
      <div className="rounded-8 pos-r" style={{ height: 60, border: '1px solid rgba(0, 0, 0, 0.43)' }}>
        <Skeleton className="d-block rounded-6 pos-a" style={{ height: 12, width: 68, top: 14, left: 16 }} />
        <Skeleton
          className="d-block rounded-6 pos-a"
          style={{ height: 16, width: 144, maxWidth: 'calc(100% - 60px)', left: 16, bottom: 11 }}
        />
        <i className="icon icon-arrow-down3 pos-a" style={{ right: 12, bottom: 18 }} aria-hidden />
      </div>

      <div className="mt-2 size-16 w-100">
        <div className="px-0_25 d-flex flex-column align-items-center">
          <div className="d-flex align-items-center mb-0_25 mw-100" style={{ height: 22 }}>
            <Skeleton className="d-block rounded-6" style={{ height: 16, width: 205, maxWidth: '100%' }} />
          </div>
          <div className="d-flex align-items-center" style={{ height: 36 }}>
            <Skeleton className="d-block rounded-6" style={{ height: 30, width: 110 }} />
          </div>
        </div>

        {isDealerlessOem && (
          <div className="mt-2 mb-1">
            <div className="d-flex align-items-center" style={{ height: 22 }}>
              <Skeleton className="d-block rounded-6 w-100" style={{ height: 16 }} />
            </div>
            <div className="d-flex align-items-center" style={{ height: 22 }}>
              <Skeleton className="d-block rounded-6 w-75" style={{ height: 16 }} />
            </div>
          </div>
        )}

        <Skeleton
          className={classnames('d-block rounded-8 w-100', { 'mt-2': !isDealerlessOem })}
          style={{ height: 46 }}
        />

        {!isDealerlessOem && (
          <div className="d-flex align-items-center mt-0_25" style={{ height: 16 }}>
            <Skeleton className="d-block rounded-6" style={{ height: 12, width: 112 }} />
          </div>
        )}

        <div className="mt-1 mb-0_5">
          <div className="d-flex align-items-center justify-content-center" style={{ height: 20 }}>
            <Skeleton className="d-block rounded-6" style={{ height: 14, width: '95%' }} />
          </div>
          <div className="d-flex align-items-center justify-content-center" style={{ height: 20 }}>
            <Skeleton className="d-block rounded-6" style={{ height: 14, width: '90%' }} />
          </div>
          <div className="d-flex align-items-center justify-content-center" style={{ height: 20 }}>
            <Skeleton className="d-block rounded-6" style={{ height: 14, width: '95%' }} />
          </div>
        </div>
      </div>
    </div>
  );
}

TrimsCtaSkeleton.propTypes = {
  isDealerlessOem: PropTypes.bool,
};
